// extracted by mini-css-extract-plugin
export default {"delivery_photo":"deliveryPhoto_delivery_photo__H5H1j"};